import type { ComponentType } from 'react'

export function getComponentName(target: ComponentType<any | string>) {
    const targetType =
        process.env.NODE_ENV !== 'production'
            ? typeof target === 'string' && target
            : false
    return targetType || target.displayName || target.name || 'Component'
}
